// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
const { createElement, getElement, getElements } = window.BAO.Utils
const { useArrows } = window.BAO.Carousel.plugins

class LoyaltyTierOverview extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['widget']
  }

  setupListeners () {
    super.setupListeners()

    const waitForContentPopulation = setInterval(() => {
      const isAlreadyPopulated = this.els.widget?.element.firstChild
      if (!isAlreadyPopulated && window.loyaltylion?.ui?.rendered) {
        return
      }

      clearInterval(waitForContentPopulation)

      this.renderWidget()
    }, 2000)

    window.addEventListener('loyaltyLion:refresh', () => {
      this.renderWidget()
    })
  }

  renderWidget () {
    const widget = this.els.widget.element

    const tierContainers = getElements('.lion-tier-box', { context: widget })
    this.renderTiers(tierContainers)

    const slider = getElement('.lion-tier-overview', { context: widget })
    if (slider) {
      this.carousel = this.initialiseCarousel(slider)
    }
  }

  initialiseCarousel (slider) {
    const alreadyLoaded = slider.classList.contains('keen-slider')
    if (!alreadyLoaded) {
      slider.classList.add('keen-slider')

      const arrowHTML = this.els['arrow-template'].element.innerHTML
      slider.innerHTML += arrowHTML

      return new KeenSlider(
        slider,
        {
          slides: {
            loop: false,
            mode: 'snap',
            rtl: false,
            perView: 'auto',
            spacing: 10,
            origin: 'center',
          },
          initial: parseInt(this.dataset.initial),
          breakpoints: {
            '(min-width: 768px)': {
              slides: {
                origin: 'auto',
                perView: 'auto',
                spacing: 10,
              },
            },
          },
        },
        [
          carousel => {
            carousel.on('animationStarted', () => {
              const nextActiveIndex = carousel.track.absToRel(
                carousel.animator.targetIdx || 0,
              )

              carousel.slides.forEach((slide, index) => {
                slide.setAttribute('aria-current', index === nextActiveIndex)
              })

              this.activeIndex = nextActiveIndex
            })
          },
          useArrows({
            next: getElement('.ll-TierOverview_Control-next', {
              context: slider.parentElement,
            }),
            previous: getElement('.ll-TierOverview_Control-previous', {
              context: slider.parentElement,
            }),
          }),
        ],
      )
    }
  }

  /** @param {HTMLElement[]} containers */
  renderTiers (containers) {
    containers.forEach((container, index) => {
      const alreadyLoaded = container.classList.contains('keen-slider__slide')
      if (!alreadyLoaded) {
        container.classList.add('keen-slider__slide')

        const tierTitle = getElement('.lion-tier-box__title', {
          context: container,
        }).innerText.toLowerCase()

        if (container.classList.contains('lion-tier-box--previous')) {
          const completeSliderHTML = this.els['complete-slider'].element
            .innerHTML
          const footer = getElement('.lion-tier-box__footer', {
            context: container,
          })

          footer.innerHTML += completeSliderHTML
        }

        if (this.tiers[index].icon) {
          const header = getElement('.lion-tier-box__header', {
            context: container,
          })
          const icon = createElement('img', {
            class: 'll-TierOverview_TierIcon',
          })
          icon.src = this.tiers[index].icon
          header.insertAdjacentElement('afterbegin', icon)
        }

        const benefitList = getElement('.lion-tier-box__benefits-list', {
          context: container,
        })
        const drawerLink = createElement('a', {
          class:
            'll-TierOverview_BenefitLink btn-Button-underline btn-Button fz-13_162',
          href: '#',
          'data-drawers-trigger': 'loyalty-tiers',
          'data-loyalty-tier-drawer-external-el': 'trigger',
          'data-tier': tierTitle,
        })
        drawerLink.innerHTML = 'View All Benefits'
        benefitList.insertAdjacentElement('beforeend', drawerLink)
      }
    })
  }

  get tiers () {
    const currentTierName = this.getAttribute('current-tier')
    const tierIcons = JSON.parse(this.dataset.tierIcons)

    return window.loyaltylion.program.loyaltyTiers.map(tier => {
      const icon = tierIcons.find(tierIcon => tierIcon.tier === tier.position)
        ?.icon
      const isCurrent = tier.name === currentTierName

      return {
        icon,
        isCurrent,
        ...tier,
      }
    })
  }

  get currentTier () {
    return this.tiers.find(tier => tier.isCurrent)
  }
}

if (!customElements.get('loyalty-tier-overview')) {
  customElements.define('loyalty-tier-overview', LoyaltyTierOverview)
}
